import React from "react";

function AboutUs() {
    return (
        <div id="about-outer">
            <div id="about-us">
                <h1>About Us</h1>
                <br />
                <h2>Our Mission</h2>
                <p>At Your Company Name, our mission is to [describe your mission and what you aim to achieve].</p>

                <h2>Our Story</h2>
                <p>Your Company Name was founded in [year] with a vision to [brief description of how and why the company was founded]. Since then, we have [highlight key milestones and achievements].</p>

                <h2>Meet Our Team</h2>
                <ul>
                    <li>
                        <h3>Founder/CEO Name</h3>
                        <p>Founder/CEO Name is the driving force behind Your Company Name. With [years] of experience in [industry], he/she/they bring unique expertise or perspective.</p>
                    </li>
                </ul>

                <h2>Our Values</h2>
                <ul>
                    <li>Customer Satisfaction: We prioritize customer happiness and strive to exceed expectations.</li>
                    <li>Innovation: We embrace creativity and are always seeking new ways to improve.</li>
                    <li>Integrity: We conduct business with honesty, transparency, and respect for all stakeholders.</li>
                    <li>Community: We are committed to making a positive impact in the communities we serve.</li>
                </ul>

                <h2>Testimonials</h2>
                <blockquote>
                    <p>"[Customer Testimonial 1]"</p>
                    <footer>- [Customer Name]</footer>
                </blockquote>
                <blockquote>
                    <p>"[Customer Testimonial 2]"</p>
                    <footer>- [Customer Name]</footer>
                </blockquote>

                <h2>Awards and Recognition</h2>
                <ul>
                    <li>[Award 1] - [Year]</li>
                    <li>[Award 2] - [Year]</li>
                </ul>

                <h2>Get in Touch</h2>
                <p>We'd love to hear from you! Contact us at [email address] or [phone number].</p>

                <h2>Follow Us</h2>
                <ul>
                    <li><a href="[Facebook URL]">Facebook</a></li>
                    <li><a href="[Twitter URL]">Twitter</a></li>
                    <li><a href="[Instagram URL]">Instagram</a></li>
                    <li><a href="[LinkedIn URL]">LinkedIn</a></li>
                </ul>
            </div>
        </div>
    );
}

export default AboutUs;
